module.exports = __webpack_public_path__ + "static/fonts/ysbth.1726685.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/ysbth.ttf
// module id = zPST
// module chunks = 1